import React from 'react';
import { teamMembers } from '../mockData';

const Team = () => {
  return (
    <div className="page-container">
      {/* Page Header */}
      <section className="page-header">
        <h1 className="page-title">Meet Our Team</h1>
        <p className="page-subtitle">
          The talented professionals behind StoryBox Solutions
        </p>
      </section>

      {/* Team Grid */}
      <section className="team-section">
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <div className="team-image-container">
                <img src={member.image} alt={member.name} className="team-image" />
              </div>
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <p className="team-position">{member.position}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Join Team CTA */}
      <section className="join-team-section">
        <h2 className="section-title">Want to Join Our Team?</h2>
        <p className="section-subtitle">
          We're always looking for talented individuals who are passionate about technology.
        </p>
        <a href="/career" className="btn-primary">
          View Open Positions
        </a>
      </section>
    </div>
  );
};

export default Team;
